import Storage from './Storage'
import Errors from './Errors'
import Validator from './validator/Validator'
import {capitalize, APIService, cloneObject, isArrayWithObjects} from '@utils'

let uid = 1

export default class Form extends Storage
{
    constructor( data = {}, rules = [], labels = {}, uniqueIndexParam = false, options = {} ) {
        super() // call parent

        this.$_options = options
        this.$afterInit = []

        this.setRules(rules)
        this.getValidator().setUniqueKeyParam(uniqueIndexParam)
        this.useUniqueIndex((uniqueIndexParam !== false))

        this.load(data, true) /* load need to be after setRules() */
        this.setLabels(labels)

        this.$afterInit.forEach( callback  => {
            callback(this)
        })
    }

    getOptions() {
        return this.$_options
    }

    setOptions(options) {
        this.$_options = options
        return this
    }

    useUniqueIndex(cond) {
        this.$_useUniqueIndex = Boolean(cond)
    }

    static trimAll( data ) {
        for(let key in data) {
            if( typeOf(data[key]) == 'object' || Array.isArray(data[key]) ) {
                Form.trimAll(data[key])
            } else if( typeof data[key] === 'string' ) {
                data[key] = data[key].trim()
            }
        }
    }

    static getNextUniqueID() {
        return 'uid-' + ++uid
    }

    static createUniqueIndex(data, param) {

        let create = function (data) {
            for( let index in data ) {
                let object = data[index]

                if ( ! object.hasOwnProperty(param) ) {
                    Object.defineProperty(object, param, {
                        value: Form.getNextUniqueID(),
                        enumerable: false,
                        writable: false
                    })
                }

                Form.createUniqueIndex(object, param)
            }
        }

        if( isArrayWithObjects(data) ) {
            create(data)
        } else {
            for( let key in data ) {
                if( isArrayWithObjects(data[key]) ) {
                    create(data[key])
                }
            }
        }
    }

    registerAfterInitHandler(callback) {
        this.$afterInit.push(callback)
    }

    setLabels( labels ) {
        this.$labels = labels
    }

    hasFieldLabel( field ) {
        let label = this._getFieldLabel(field)

        return ! isEmpty(label)
    }

    getFieldLabel( field ) {
        let label = this._getFieldLabel(field)

        if(isEmpty(label))
            label = capitalize(field.split('.').pop()) // use field name

        return label
    }

    _getFieldLabel( field ) {
        let labelSchemaField = this.getValidator().findSchemaFields(field, true, this.$labels)

        if( false === labelSchemaField ) {
            return
        }

        return this.$labels[labelSchemaField]
    }

    init() {
        this.$options = {}
    }

    getValidator() {
        return this.$validator
    }

    setScenario( scenario ) {
        this.getValidator().setScenario(scenario)
        return this
    }

    isLoading() {
        return this.getValidator().hasLoadingField()
    }

    setLanguage( language ) {
        this.getValidator().setLanguage(language)
        return this
    }

    touchField( field ) {
        this.getValidator().registerDirtyField(field)
    }

    resetField( field ) {
        this.getValidator().unregisterDirtyField(field)
        this.getValidator().unregisterLoadingField(field)

        let uniqueField = this.getValidator().getUniqueFieldKey(field)
        this.getValidator().warnings().remove(uniqueField)
        this.getValidator().errors().remove(uniqueField)
    }

    load( data = {}, useAsOriginalData = false ) {
        let cloned = cloneObject(data)

        if( this.$_useUniqueIndex ) {
            Form.createUniqueIndex(cloned, this.getValidator().getUniqueKeyParam())
        }

        this.setMultiple(cloned)

        // this data will be used on form reset
        if( useAsOriginalData ) {
            this.$originalData = cloneObject(cloned) // clone object
        }
    }

    replace( key, data ) {
        let cloned = cloneObject(data)

        if( this.$_useUniqueIndex ) {
            Form.createUniqueIndex(cloned, this.getValidator().getUniqueKeyParam())
        }

        super.replace(key, cloned)

        this.$originalData[key] = cloneObject(cloned)
    }

    setRules( rules = [] ) {
        this.$validator = new Validator(this, rules)
    }

    // validation
    validate() {
        return this.getValidator().validate()
    }

    validator() {
        return this.getValidator()
    }

    addError(field, error) {
        this.getValidator().errors().add(field, error)
    }

    addWarning(field, error) {
        this.getValidator().warnings().add(field, error)
    }

    reset() {
        this.getValidator().reset()
        this.load(this.$originalData)
    }

    // submit
    submit( type, url ) {
        let api = url
        let options = {}
        let method = null

        if( Array.isArray(url) ) {
            [api, method = null, options = {}] = url
        }

        this.validate().then( result => {
            if( ! result.valid ) {
                return result
            }

            return APIService.request(
                api,
                method,
                this.getData(),
                type,
                options
            )
        })
    }

    POST( url ) {
        this.submit('POST', url)
    }

    GET( url ) {
        this.submit('GET', url)
    }

    PUT( url ) {
        this.submit('PUT', url)
    }

    DELETE( url ) {
        this.submit('DELETE', url)
    }

    // data management
    getOriginalData() {
        return this.$originalData || {}
    }

    getData( onlyNotEmptyFields = false, onlyChanged = false ) {
        let data = this.all()

        return cloneObject(data) // deep copy

        // return {
        //     data: data,
        //     summary: {
        //         added: {
        //             'a.items.sub[0].nested[3]',
        //         },
        //         removed: {
        //
        //         },
        //         updated: {
        //             'a.items.sub[0].test',
        //             'a.items.sub[0].nested[2]'
        //         }
        //     ],
        //     originalData: this.$originalData,
        //     query: {
        //         article_id: 123,
        //         flt_msisdn: 1456212
        //     }
        // }
        //
        // var a = {
        //     items: {
        //         id: 123, // -- updated
        //         sub: [
        //             0: {id: 1, test: '1 -- updated', nested: [ 'a', 123, 'b', 'c' // c is -- added ]},
        //             1: {id: 2, test: '2'},
        //             2: {id: 3, test: '3'},
        //             3: {id: 4, test: '4 -- removed'},
        //             4: {id: 5, test: '5 -- added'},
        //         ],
        //         c: {
        //             a: 12,
        //             d:3121,
        //             h: 1231
        //         },
        //         d: 'awdaw' // added
        //      }
        // }
        //
        //
        // removed [ a.items.sub[3] ]
        // added   [ a.items.sub[4], a.items.d ]
        //
        // updated [ a.items.sub[0].test, a.items.sub[0].nested[2], a.items.id ]
        //
        //
        //
        // ako e masiv - do index vkluchitelno
        // ako e obekt - do kluch
        //
        // --------------------------------------

        // let result = {}
        // Object.keys(data).forEach( field => {
        //     let value = data[field]
        //
        //
        // })
    }
}
